import * as yup from "yup";

const companyDataSchema = yup.object({
  enterpriseName: yup.string().required(),
  producttypeKey: yup.string().required(),
  countryKey: yup.string().required()
}).required();

export default companyDataSchema;
